<template>
  <pop-open-box v-if="!embed" :default-show="defaultShow" v-slot="{ closePopup }" name="login-form"
                class="flex flex-col justify-center items-center from-brand-blue-gradient to-white via-brand-blue-gradient2"
                bg-class="bg-gradient-to-b lg:bg-gradient-to-r"
                :screen-height="!defaultShow">
    <div class="container max-w-5xl mx-auto mt-12 px-4">
      <img class="mx-auto h-24 w-auto" src="/app/images/hurst-logo-h.svg" alt="Hurst Review Logo"/>
      <h2 class="mt-4 bg-clip-text text-transparent bg-gradient-to-r from-brand-orange-500 to-brand-orange-400 text-center text-lg sm:text-xl md:text-3xl font-bold mb-8">
        Access Your Account
      </h2>
      <section
          class="w-full mx-auto mt-4 bg-white border border-brand-gray-400 rounded-2xl px-3 py-8 grid grid-cols-1 lg:grid-cols-2 lg:gap-4 lg:divide-x divide-y lg:divide-y-0">
        <div class="flex flex-col justify-between">
          <h2 class="mt-4 bg-clip-text text-transparent bg-gradient-to-r from-brand-orange-500 to-brand-orange-400 text-center text-lg sm:text-xl md:text-3xl font-bold mb-8">
            Students
          </h2>
          <div
              class="bg-brand-orange-100 border border-brand-orange-500 text-brand-orange-500 px-4 py-3 rounded-2xl relative mb-4"
              role="alert"
              v-if="error !== null">
            <strong class="font-bold">{{ error.title }}</strong>
            <span class="block sm:inline">{{ error.detail }}</span>
          </div>
          <form class="px-4" @submit.prevent="login">
            <div class="mb-4 md:grid md:grid-cols-4 md:gap-6 items-center">
              <label class="block text-sm font-medium uppercase leading-5 text-brand-gray-600" for="username">
                Email
              </label>
              <div class="md:col-span-3 mt-1 md:mt-0 rounded-lg shadow-sm">
                <input v-model="username"
                       class="appearance-none block w-full px-3 py-4 border border-brand-gray-300 rounded-lg shadow-inner placeholder-brand-gray-500 focus:outline-none focus:ring-brand-teal focus:border-brand-teal transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                       id="username" type="text" placeholder="email@example.com" required>
              </div>
            </div>
            <div class="mb-4 md:grid md:grid-cols-4 md:gap-6 items-center">
              <label class="block text-sm font-medium uppercase leading-5 text-brand-gray-600" for="password">
                Password
              </label>
              <div class="md:col-span-3 mt-1 md:mt-0 rounded-lg shadow-sm">
                <input v-model="password"
                       class="appearance-none block w-full px-3 py-4 border border-brand-gray-300 rounded-lg shadow-inner placeholder-brand-gray-500 focus:outline-none focus:ring-brand-teal focus:border-brand-teal transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                       id="password" type="password" placeholder="password" required>
              </div>
            </div>
            <div class="md:grid md:grid-cols-2 md:gap-6 items-center">
              <button class="btn btn-orange rounded-full w-full login-btn"
                      type="submit">Log In
              </button>
              <a class="block mt-4 md:mt-0 md:order-first align-baseline uppercase underline text-sm text-right text-blue-700 hover:text-blue-800"
                 href="/forgot-password">
                Forgot Password?
              </a>
            </div>
            <div v-if="!defaultShow" class="flex justify-end mt-4">
              <a class="block align-baseline text-sm text-blue-700 hover:text-blue-800 mb-8" href="#"
                 @click.prevent="closePopup">
                Cancel
              </a>
            </div>
          </form>
        </div>
        <div v-if="showEduPrompt" class="px-4 flex flex-col justify-between">
          <h2 class="mt-4 bg-clip-text text-transparent bg-gradient-to-r from-brand-orange-500 to-brand-orange-400 text-center text-lg sm:text-xl md:text-3xl font-bold mb-8">
            Schools/Healthcare
          </h2>
          <p class="text-lg font-medium flex-grow">Access your Dashboard account to monitor your students' progress.</p>
          <div class="mb-4 lg:grid lg:grid-cols-2 lg:gap-6 items-center max-w-sm mx-auto lg:max-w-none">
            <div class="mt-4 lg:mt-0 lg:col-start-2 space-y-6">
              <a href="https://educators.hurstreview.com/dashboard/login"
                 target="_blank"
                 class="btn btn-dashboard-login rounded-full block w-full dashboard-btn"
              >Visit the Dashboard</a>
            </div>
          </div>
        </div>
      </section>

    </div>
  </pop-open-box>
  <form v-else @submit.prevent="login" class="space-y-6">
    <h2 class="mt-4 bg-clip-text text-transparent bg-gradient-to-r from-brand-orange-500 to-brand-orange-400 text-center text-lg sm:text-xl md:text-3xl font-bold mb-8">
      Student Account
    </h2>
    <div
        class="rounded-md bg-red-50 p-4"
        role="alert"
        v-if="error !== null">
      <span class="text-sm text-red-700">{{ error.detail }}</span>
    </div>
    <div>
      <div><label class="block text-sm font-medium leading-5 text-hurst-blue" for="loginEmailAddress">
        Email Address
      </label>
        <div class="mt-1 md:mt-0">
          <input
              class="appearance-none block w-full px-3 py-2  border border-hurst-blue rounded shadow-inner placeholder-brand-gray-500 focus:outline-none focus:ring-hurst-teal focus:border-hurst-teal transition duration-150 ease-in-out sm:text-sm sm:leading-5"
              v-model="username"
              required
              autocomplete="email"
              id="loginEmailAddress" type="text" placeholder="nursing.student@example.com">
        </div>
      </div>
    </div>
    <div>
      <label class="block text-sm font-medium leading-5 text-hurst-blue" for="loginPassword">
        Password
      </label>
      <div class="md:col-span-3 mt-1 md:mt-0 rounded-lg shadow-sm">
        <input v-model="password"
               class="appearance-none block w-full px-3 py-2  border border-hurst-blue rounded shadow-inner placeholder-brand-gray-500 focus:outline-none focus:ring-hurst-teal focus:border-hurst-teal transition duration-150 ease-in-out sm:text-sm sm:leading-5"
               autocomplete="current-password"
               id="loginPassword" type="password" placeholder="password" required>
      </div>
    </div>
    <div>
      <a class="block text-hurst-blue text-sm font-bold"
         href="/forgot-password">
        Forgot Password?
      </a>
    </div>
    <div>
      <button class="w-full my-6 text-white font-semibold text-base py-2 md:py-4 px-4 md:px-8 rounded-[80px] bg-gradient-to-br from-[#ffa807] to-[#EE5914] hover:from-[#EE5914] hover:to-[#ffa807] transition-all duration-500 ease-in-out bg-size-200 bg-pos-0 hover:bg-pos-100 text-center flex justify-center self-center"
              type="submit">Log In
      </button>
    </div>
  </form>
</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import Bugsnag from "@bugsnag/js";

export default {
  name: 'LoginForm',
  props: {
    embed: {
      type: Boolean,
      default: false
    },
    redirectTo: {
      type: String,
      default: null,
      required: false,
    },
    defaultShow: {
      type: Boolean,
      default: false,
    },
    showEduPrompt: {
      type: Boolean,
      default: true,
    }
  },

  data() {
    return {
      error: null,
      password: '',
      username: '',
    };
  },

  methods: {
    async login() {
      try {
        Swal.fire({
          title: 'Please Wait',
          icon: 'info',
          html: 'We are attempting to log you into your account<br/><i class="fal fa-spinner fa-spin fa-3x"></i>',
          showCloseButton: false,
          showConfirmButton: false,
        });
        const {data} = await axios.post('/login', {
          username: this.username,
          password: this.password,
        });
        localStorage.setItem('userId', data.userId);
        localStorage.setItem('sessionId', data.sessionId);
        if (this.redirectTo === null) {
          window.location = data.redirect;
        } else {
          window.location = this.redirectTo;
        }
      } catch (e) {
        Swal.close();
        if (e.hasOwnProperty('response')) {
          if (e.response.data.title !== undefined) {
            this.error = e.response.data;
          } else {
            Bugsnag.addMetadata('response', e.response);
            Bugsnag.notify(e);
            this.error = {
              title: 'Unable to log you in.',
              detail: 'We encountered an error when trying to log you into your account. Please give us a minute and try again.',
            };
          }

        } else {
          Bugsnag.addMetadata('response', e);
          Bugsnag.notify(e);
          this.error = {
            title: 'Unable to log you in.',
            detail: 'We encountered an error when trying to log you into your account. Please give us a minute and try again.',
          };
        }
      }
    },
  },
};
</script>

<style scoped>

</style>